import { constants } from "../../../constants";

export default class Resize {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    LOTTOLAND_handler(msg) {
        this.gb.emitters.emit.game.resize(msg.actionData);
    }

    POKERSTARS_handler(msg){
        this.gb.emitters.emit.game.resize(msg);
    }

    _default(msg) {
        this.gb.emitters.emit.game.resize(msg.param);
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.walletProtocol) {
            case constants.LOTTOLAND:
                event["game.resize"] = this.LOTTOLAND_handler;
                break;
            case constants.POKERSTARS:
                event["xc2rgSizeChanged"] = this.POKERSTARS_handler;
                break;
            default:
                event["resize"] = this._default;
        }

        return event;
    }
}
